import { formatPressure, formatTemperature, getPressureVariant, getTemperatureVariant } from './utils';

export type Variant = 'default' | 'danger' | 'warning';

export const VARIANT_LABEL_CLASS: Record<Variant, string> = {
    default: 'bg-lightest border-none text-color-darkest',
    danger: 'label-danger',
    warning: 'label-warning',
};

export const VARIANT_TEXT_CLASS: Record<Variant, string> = {
    default: 'text-color-darkest',
    danger: 'text-color-danger',
    warning: 'text-color-warning',
};

export const VARIANT_BG_CLASS: Record<Variant, string> = {
    default: 'bg-lightest',
    danger: 'label-danger',
    warning: 'label-warning',
};

interface TyreLabelProps {
    children: React.ReactNode;
    variant?: Variant;
    rounded: 'left' | 'right';
}

const TyreLabel = ({ children, variant = 'default', rounded }: TyreLabelProps) => {
    const roundedClass = rounded === 'left' ? 'rounded-right-none' : 'rounded-left-none';
    return (
        <span
            className={
                `label text-size-14 text-size-12-xs text-normal width-70 width-60-xs ` +
                `${VARIANT_LABEL_CLASS[variant]} rounded-small ${roundedClass} ` +
                `padding-x-10 padding-y-2 padding-x-5-xs text-center`
            }
            style={{ flexShrink: 1 }}
        >
            <span>{children}</span>
        </span>
    );
};

export const PressureLabel = ({ pressure, status }: { pressure?: number | null; status?: string | null }) => (
    <TyreLabel variant={getPressureVariant(status)} rounded="left">
        {formatPressure(pressure)}
    </TyreLabel>
);

export const TemperatureLabel = ({ temperature, status }: { temperature?: number | null; status?: string | null }) => (
    <TyreLabel variant={getTemperatureVariant(status)} rounded="right">
        {formatTemperature(temperature)}
    </TyreLabel>
);
